import { useSelector } from "react-redux";
import { FlightShopStep } from "redmond";
import {
  formatShortDate,
  getLocalTime,
  getTimeDifference,
  pluralize,
} from "halifax";
import { useChfarPolicy } from "./useChfarPolicy";
import { flightShopProgressSelector } from "../../shop/reducer";
import { useChfarExerciseParams } from "./useChfarExerciseParams";

export const usePreviousFlight = () => {
  const { itineraryId, contractId } = useChfarExerciseParams();
  // We have been passing the skip param here to avoid the API call.
  // Since the PreviousFlightBanner is only render on the ChFAR exercise flow, we can omit on this hook.
  const skip = itineraryId == null || contractId == null;
  const { data, isLoading } = useChfarPolicy(
    { itineraryId: itineraryId as string, contractId: contractId as string },
    skip
  );
  const flightShopStep = useSelector(flightShopProgressSelector);

  const isChooseDeparture = flightShopStep === FlightShopStep.ChooseDeparture;

  if (isLoading) {
    return { isLoading };
  }

  if (!data) {
    return null;
  }

  const slice = data.slices[isChooseDeparture ? 0 : 1];

  if (!slice) {
    return null;
  }

  const {
    destinationName,
    destinationCode,
    airlines,
    stops: numberOfStops,
    departureDate,
    arrivalDate,
  } = slice;

  const formattedDate = formatShortDate(departureDate);
  const departureTime = getLocalTime(departureDate);
  const arrivalTime = getLocalTime(arrivalDate);

  const stops = `${numberOfStops} ${pluralize(numberOfStops, "stop", "stops")}`;

  const flightStops = numberOfStops === 0 ? "Nonstop" : stops;

  const flightDuration = getTimeDifference(arrivalDate, departureDate);

  return {
    formattedDate,
    departureTime,
    destinationName,
    destinationCode,
    arrivalTime,
    flightDuration,
    flightStops,
    airlines,
    isLoading,
  };
};
